import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import selectors from 'redux/selectors/selectors';
import { Icon } from 'shared/components';
import { useState } from 'react';
import { UpgradeModal } from '../upgrade/upgrade-modal';
import { LimitUpgradeModal } from '../upgrade/limit-upgrade-modal';

export function AddMonitorFeature() {
  const navigate = useNavigate();
  const isFreeTier = useSelector(selectors.isFreeTier);
  const accountInfo = useSelector(selectors.accountInfo);

  const [showFreeTierUpgrade, setShowFreeTierUpgrade] = useState(false);
  const [showLimitUpgrade, setShowLimitUpgrade] = useState(false);

  const openModal = () => {
    if (accountInfo?.usage?.sites_usage >= accountInfo?.usage?.sites_limit) {
      const swap = isFreeTier ? setShowFreeTierUpgrade : setShowLimitUpgrade;
      swap(true);
      return;
    }
    navigate('/dashboard/site/add');
  };
  return (
    <>
      <Button
        id={'add-edit-monitor-btn'}
        onClick={openModal}
        className="primary_big"
        icon={
          <Icon
            name="plus"
            size={11}
            style={{ marginTop: 3 }}
          />
        }>
        Add Monitor
      </Button>

      {showFreeTierUpgrade && (
        <UpgradeModal
          show={showFreeTierUpgrade}
          onHide={() => setShowFreeTierUpgrade(false)}
        />
      )}

      {showLimitUpgrade && (
        <LimitUpgradeModal
          show={showLimitUpgrade}
          onHide={() => setShowLimitUpgrade(false)}
          limitType="monitors"
          currentUsage={accountInfo?.usage?.sites_usage}
          maxLimit={accountInfo?.usage?.sites_limit}
        />
      )}
    </>
  );
}
